import ReportCampaignOverviewV2 from './reportCampaignOverviewV2'
export default ReportCampaignOverviewV2
